import React from 'react';

const error = (props) => {
    if (!props.errorMsg || props.errorMsg === '') {
        return null;
    }
    return (
        <div className="alert alert-danger alert-white rounded mT5">
            {/*<button type="button" data-dismiss="alert" aria-hidden="true" className="close">×</button>*/}
            <div className="icon"><i className="fa fa-info-circle"></i></div>
            <span dangerouslySetInnerHTML={{__html: props.errorMsg}}></span>
        </div>
        // <div className="row">
        //     <div className={props.divClass}>
        //         <div className="error-wrap">
        //             <p className="error-msg" dangerouslySetInnerHTML={{__html: props.errorMsg}}/>
        //         </div>
        //     </div>
        // </div>
    )
};

export default error;